import React, { useEffect, useState } from "react";
import UserDetailsForm from "./UserDetailsForm"; // Assuming this component exists
import MemberList from "./MemberList"; // Assuming this component exists
import { getMembers } from "../../services/auth";

const UserForm = ({ user, onClose }) => {
  // State to manage the active tab
  const [activeTab, setActiveTab] = useState("userDetails");

  const [members, setMembers] = useState(null);

  useEffect(() => {
    if (user) {
      const fetchInitialData = async () => {
        try {
          const memebersData = await getMembers(user.ID);
          setMembers(memebersData.user.family || []);
        } catch (err) {
          console.error("Error fetching initial data:", err);
          // Optionally set an error state to show a message to the user
        }
      };
      fetchInitialData();
    }
  }, [user]);

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 flex flex-col items-center justify-center">
      <h2 className="text-lg font-semibold mb-4">
        {user ? "Edit User" : "Add New User"}
      </h2>

      {/* Tab navigation */}
      <div className="tabs mb-4">
        <button
          onClick={() => setActiveTab("userDetails")}
          className={`px-4 py-2 ${
            activeTab === "userDetails"
              ? "bg-blue-500 text-white"
              : "bg-gray-300"
          }`}
        >
          User Details
        </button>
        <button
          onClick={() => setActiveTab("familyDetails")}
          className={`px-4 py-2 ${
            activeTab === "familyDetails"
              ? "bg-blue-500 text-white"
              : "bg-gray-300"
          }`}
        >
          Family Details
        </button>
      </div>

      {/* Tab content */}
      {activeTab === "userDetails" && (
        <UserDetailsForm user={user} onClose={onClose} />
      )}
      {activeTab === "familyDetails" && (
        <MemberList
          mainUserId={user.ID}
          members={members}
          onClose={onClose}
          setMembers={setMembers}
        />
      )}
    </div>
  );
};

export default UserForm;
